import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";

const MainPageStorylaneOverlay = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.storylane.io/js/v2/storylane.js";
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <Box
      maxW="1240px"
      mx="auto"
      my={8}
      px={4}
    >
      <div
        className="sl-embed"
        style={{
          position: "relative",
          paddingBottom: "calc(98.48% + 25px)",
          width: "100%",
          height: "0",
          transform: "scale(1)",
        }}
      >
        <iframe
          loading="lazy"
          title="iframe-demo"
          className="sl-demo"
          src="https://app.storylane.io/demo/jujsgmk1mjht?embed=inline"
          name="sl-embed"
          allow="fullscreen"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "1px solid rgba(63,95,172,0.35)",
            boxShadow: "0px 0px 18px rgba(26, 19, 72, 0.15)",
            borderRadius: "10px",
            boxSizing: "border-box",
          }}
        />
      </div>
    </Box>
  );
};

export default MainPageStorylaneOverlay;
